import Vue from 'vue'

Vue.component('checkbox-group', {
  props: {
    name: String,
    label: String,
    dynamicLabel: Function,
    modifier: {
      type: String,
      default: 'default'
    },
    placeholder: String,
    options_json: String,
    error: String,
    required: Boolean,
    validateMethod: Function
  },
  data () {
    const data = {
      labelStr: '',
      inputValue: [],
      isActive: false,
      isValid: false,
      selectedText: '',
      options: [],
      showErrorMessage: false,
      errorMessage: ''
    }
    if (this.dynamicLabel && typeof this.dynamicLabel === 'function') {
      data.labelStr = this.dynamicLabel(this.name)
    } else if (this.label) {
      data.labelStr = this.label
    } else if (this.placeholder) {
      data.labelStr = this.placeholder
    }
    if (this.options_json) {
      try {
        data.options = JSON.parse(this.options_json)
      } catch (error) {
        data.options = []
      }
    }
    data.options.forEach((item, index) => {
      data.options['id'] = this.name + '-' + item.value + '-' + Math.ceil(Math.random() * 50)
      data.options['isActive'] = false
    })
    return data
  },
  mounted () { },
  methods: {
    validateInput () {
      if (this.validateMethod) {
        const validation = this.validateMethod({
          value: this.inputValue,
          name: this.name
        })
        this.isValid = validation.valid
        this.errorMessage = validation.message
      } else if (this.required && !this.inputValue.length === 0) {
        this.isValid = false
      } else {
        this.isValid = true
      }
      return this.isValid
    },
    onChange: function (value) {
      const values = []
      this.options.forEach((item, index) => {
        if (item.value === value) {
          if (item.isActive) {
            item.isActive = false
          } else {
            item.isActive = true
          }
        }
        if (item.isActive) {
          values.push(item.value)
        }
      })
      this.inputValue = values
      this.$emit('change', {
        name: this.name,
        value: this.inputValue
      })
    }
  },
  template: `
  <div
    class="multi-option"
    :class="['multi-option--'+modifier]">
    <div class="multi-option__wrapper">
      <div class="multi-option__title">{{ labelStr }}</div>
      <ul class="multi-option__el_list">
        <li v-for="option in options" class="multi-option__el" :key="option.value" :class="[(option.isActive)?'is-active': '']">
          <label class="multi-option__label" tabindex="0">
            <span>{{(option.label)}}</span>
            <div class="multi-option__icon multi-option__icon-checkbox">
              <svg class="checkbox__icon-tick" viewBox="0 0 20 20">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-checkbox" x="0" y="0"></use>
              </svg>
            <span>&nbsp;</span>
            </div>
            <input
              :name="name"
              :value="option.value"
              :checked="option.isActive"
              @change="onChange($event.target.value)"
              class="multi-option__input" type="checkbox">
          </label>
        </li>
      </ul>
    </div>
    <p v-if="!isValid" class="multi-option__error form-row__error__text-error red">{{error}}</p>
    <p style="display: none">{{ inputValue }}</p>
  </div>`
})
